import React from 'react'
import Tenders from './Tenders'
import { Link } from 'react-router-dom'
import useFetchTenderNotice from '../Hooks/API/useFetchTenderNotice';
import { NoticePDFFolder } from '../routes/addresses';
import { BASE_URL } from '../routes/config';

function RightSidebarGlobal() {
	const { getPageData, loading } = useFetchTenderNotice('/Wapi/noticelst');

    const _tender_WordCount= 5;
    
  return (
    <>
    <div class="right_sec">
        {/* <QuickLinkRight/> */}
        {/* <SearchBox/> */}

        <div className="scroll_sec_ben">
			<h2>Notice</h2>
            <div className="listNotice">
		    <div className="noticeScrollMainSub">
			{/* <marquee className="marq" height="370px" direction="up" scrollamount="4" loop="">
            <p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>59th Anniversary Celebration </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>59th Anniversary Celebration </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
    <p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>59th Anniversary Celebration </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>59th Anniversary Celebration </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
		<p>MIC, Cooperation, Govt. of West Bengal visited BENFED </p>
            </marquee> */}

			<marquee className="marq" height="370px" direction="up" scrollAmount="4" loop="">
              {!loading && getPageData?.length > 0 ? (
                getPageData.map((item, index) => (
                  <p key={index}>
					<a href={BASE_URL + '/' + NoticePDFFolder + item?.file_name} target='_blank' rel="noreferrer">
                    {item?.subject?.length > 120
                      ? item.subject.slice(0, 120) + '...'
                      : item.subject}
					</a>
                  </p>
                ))
              ) : (
                <p>Loading notices...</p>
              )}
            </marquee>
            </div>
            </div>
			{/* <a href="#">View All</a> */}
      <Link to="/notice" className="view-all-link"> View All </Link>
		</div>
    </div>
    </>
  )
}

export default RightSidebarGlobal